var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCardPacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 128,
    viewBox: "0 0 96 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_885_2760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 9.87954V114.12C3 119.024 7.1218 122.995 12.2005 122.995V1C7.1218 1 3 4.97624 3 9.87954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8801 117.592V6.40349C19.8801 3.42273 22.3907 1 25.4857 1H31.5499V50.9796C29.5662 52.7221 27.8851 54.5681 26.5269 56.243C25.5978 57.3916 24.823 58.4539 24.2118 59.35C23.8467 59.8828 23.539 60.3553 23.292 60.7487C22.7819 61.5585 22.7811 62.4375 23.2911 63.248C23.5382 63.6407 23.8459 64.1148 24.2118 64.65C24.823 65.5461 25.5978 66.6084 26.5269 67.757C27.3624 68.7876 28.3192 69.8865 29.3975 70.9806C30.0703 71.6649 30.7886 72.3492 31.5499 73.0155V122.995H25.4857C22.3907 122.995 19.8801 120.577 19.8801 117.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8094 45.5582V1H40.1855V45.5582C42.5849 44.6132 45.1993 44.0413 48 44.0413C50.8007 44.0413 53.41 44.6132 55.8094 45.5582Z",
    fill: "#1F82FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1855 78.4418V122.995H55.8094V78.4418C53.41 79.3868 50.7965 79.9587 48 79.9587C45.2035 79.9587 42.59 79.3868 40.1855 78.4418Z",
    fill: "#1F82FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4459 1H70.5143C73.6042 1 76.1157 3.42273 76.1157 6.40349V117.592C76.1157 120.577 73.6042 122.995 70.5143 122.995H64.4459V73.0245C66.4246 71.282 68.1099 69.436 69.4681 67.766C70.9527 65.9306 72.047 64.303 72.7097 63.2488C73.2189 62.4375 73.2181 61.5585 72.708 60.7479C72.0454 59.6946 70.9519 58.0677 69.4681 56.234C68.1099 54.5591 66.4246 52.7131 64.4459 50.9755V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7995 1V123C88.8824 123 93 119.024 93 114.125V9.87954C93 4.97624 88.8824 1 83.7995 1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1855 57.7289C41.2453 52.1054 44.3453 48.0347 48 48.0347C51.6505 48.0347 54.7454 52.0965 55.8094 57.7069C56.0665 59.0575 56.2065 60.4986 56.2065 61.9976C56.2065 63.4973 56.0665 64.9384 55.8094 66.2931C54.7454 71.9035 51.6547 75.9604 48 75.9604C44.3453 75.9604 41.2453 71.8905 40.1855 66.2711C39.9292 64.9245 39.7935 63.4883 39.7935 61.9976C39.7935 60.5076 39.9292 59.0755 40.1855 57.7289Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_885_2760",
    x: 0,
    y: 0,
    width: 96,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_885_2760"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_885_2760",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCardPacks);
export default __webpack_public_path__ + "static/media/empty-card-packs.1ea208cfec85416a7359489f033fbeed.svg";
export { ForwardRef as ReactComponent };